import { ReactComponent as ArrowIcon } from 'assets/icons/arrow_right.svg'

import styles from './NmaCard.module.scss'

interface Tag {
  text: string
  textColor: string
  backgroundColor: string
  isGradientColor?: boolean
}

interface Props {
  modalKey?: string
  imgSrc?: string
  tags?: Tag[]
  ouName?: string
  title: string
  onClick?: (modalKey?: string) => void
  imgCustomPosition?: React.CSSProperties
}

const NmaCard = ({ imgSrc, tags, ouName, title, onClick, modalKey, imgCustomPosition }: Props) => {
  return (
    <div className={styles.NmaCard} onClick={() => onClick && onClick(modalKey)}>
      <div className={styles.topContainer}>
        <div className={styles.coverImageWrapper}>
          {imgSrc && <img src={imgSrc} alt={title} className={styles.coverImage} style={imgCustomPosition} />}
        </div>
      </div>

      <div className={styles.bottomContainer}>
        <div className={styles.tagsContainer}>
          {tags?.map(({ text, textColor, backgroundColor, isGradientColor }, index) => (
            <div key={index} className={styles.tagWrapper} style={{ backgroundColor }}>
              <div
                className={styles.tag}
                style={
                  !isGradientColor
                    ? {
                        color: textColor,
                      }
                    : {
                        background: textColor,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                      }
                }
              >
                <span>{text}</span>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.titleContainer}>
          <div className={styles.title}>{title}</div>
        </div>

        <div className={styles.footer}>
          <div className={styles.ouName}>{ouName}</div>
          <div className={styles.linkContainer}>
            <div className={styles.linkIcon}>
              <ArrowIcon style={{ width: '14px', height: 'auto' }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default NmaCard
